import { getI18n } from './i18n';
function createLog(type, name) {
    return function (key, args) {
        const msg = `[vxe ${name || ''}] ${getI18n(key, args)}`;
        console[type](msg);
        return msg;
    };
}
const version = "3.0.32";
export const log = {
    create: createLog,
    warn: createLog('warn', `v${version}`),
    err: createLog('error', `v${version}`)
};
